import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';
import { Plus, Edit, Trash2, Search, Filter } from 'lucide-react';
import './Products.css';
import { handleGetApi, handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const Products = () => {
  const navigate = useNavigate();
   const token = JSON.parse(Cookies.get('auth_token'));
  const headers = {
    Authorization: token
  }
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  console.log(products,'products')
const fetchProduct = async () => {
    const res = await handleGetApi('admin/get/product', headers);
    setProducts(res.data)
  }
  useEffect(() => {
    fetchProduct();
  }, [])
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      const res = await handlePostApi('admin/delete/product', { id }, headers);
      setProducts(products.filter(p => p.id !== id));
    }
  };
    const filteredProducts = useMemo(() => {
      if (!search.trim()) return products;
      return products.filter(item => item?.name.toLowerCase().includes(search.toLocaleLowerCase()))
    }, [products, search])

  return (
    <MainLayout title="Product Management">
      <div className="products-container fade-in">
        <div className="products-header">
          <div className="search-filters">
            <div className="search-input">
              <Search size={18} />
              <input value={search} onChange={(e) => { setSearch(e.target.value) }} type="text" placeholder="Search products..." />
            </div>
           
          </div>
          <button className="add-product-btn" onClick={() => navigate('/products/add')}>
            <Plus size={20} />
            <span>Add Product</span>
          </button>
        </div>

        <div className="products-card">
          <div className="table-responsive">
            <table className="products-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Category</th>
                  <th>SKU</th>
                  <th>Price</th>
                  <th>Stock</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.map((product) => (
                  <tr key={product.id}>
                    <td className="product-cell">
                      <img src={`${process.env.REACT_APP_IMAGE_URL}products/${product?.thumbnail}`} alt={product.name} />
                      <div className="product-info">
                        <span className="product-name">{product.name}</span>
                        <span className="product-cat-small">{product.category_name} {product.subcategory_name && `> ${product.subcategory_name}`}</span>
                      </div>
                    </td>
                    <td>{product.category_name}</td>
                    <td><code className="sku-code">{product.sku || 'N/A'}</code></td>
                    <td className="product-price">{product.price}</td>
                    <td>
                      <span className={`stock-status ${product.stock > 10 ? 'in-stock' : product.stock > 0 ? 'low-stock' : 'out-of-stock'}`}>
                        {product.stock} left
                      </span>
                    </td>
                    <td>
                      <span className={`status-pill ${product.status.toLowerCase()}`}>
                        {product.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-btns">
                        <button className="edit-btn" onClick={() => navigate(`/products/edit/${product.id}`)}>
                          <Edit size={18} />
                        </button>
                        <button className="delete-btn" onClick={() => handleDelete(product.id)}>
                          <Trash2 size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Products;
